import React, { useRef, useEffect, useState } from "react";
import { VStack, Text, HStack, Box, Pressable, ScrollView } from "native-base";
import {
  CreateClass,
  CreateCommunity,
  CreateElite,
  CreateGraduation,
  CreateGroup,
  CreateNeighborhood,
  CreateOrganization,
  CreateSchool,
  CreateTeam,
  CreateLeagues,
  CreatePerformanceGroup,
  CreateClub,
} from "../../assets/icons/icon-assets";
import { useSelector, RootStateOrAny } from "react-redux";
import { useNavigate } from "react-router-dom";
import EntityProfilePic from "../../components/common/EntityProfilePic";
import * as AV from "../../AVCore/AVCore";
import { Loc } from "../../App/Loc";
import "driver.js/dist/driver.css";
import { driver } from "driver.js";

const CreateNew = ({
  setShowCreateNewPage,
  setType,
  passEntity,
  setPassEntity,
  leagueGameEntity,
  setIsShowEdit,
}) => {
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement | null>(null);

  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );

  const [isAttending, setIsAttending] = useState(false);
  const [attendingPlayers, setAttendingPlayers] = useState<
    AV.IParticipantLink[]
  >([]);
  const [notAttendingPlayers, setNotAttendingPlayers] = useState<
    AV.IParticipantLink[]
  >([]);

  //const getAttendingPlayers = (participants = []) => {
  //  return participants.filter((p) => p?.status === "Yes");
  //};

  //const getNotAttendingPlayers = (participants = []) => {
  //  return participants.filter(
  //    (p) =>
  //      p?.status === undefined || p?.status === "No" || p?.status === "RSVP",
  //  );
  //};

  //const loadAttendance = async () => {
  //  const homeAttending = getAttendingPlayers(homeTeam?.participants);
  //  const guestAttending = getAttendingPlayers(guestTeam?.participants);
  //  const homeNotAttending = getNotAttendingPlayers(homeTeam?.participants);
  //  const guestNotAttending = getNotAttendingPlayers(guestTeam?.participants);

  //  setAttendingPlayers([...homeAttending, ...guestAttending]);
  //  setNotAttendingPlayers([...homeNotAttending, ...guestNotAttending]);
  //};

  const handleNavigate = (type) => {
    setShowCreateNewPage(true);
    setIsShowEdit(false);
    setPassEntity?.("");
    setType(type);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const shouldHighlight =
        localStorage.getItem("highlightCreateNew") === "true";

      if (!shouldHighlight || !menuRef.current) return;

      const tour = driver({
        showProgress: false,
        allowClose: true,
        overlayClickBehavior: () => {},
        showButtons: ["close", "next"],
        doneBtnText: Loc.currentLang.inviteTourGuide.gotIt,

        onCloseClick: () => {
          localStorage.removeItem("highlightCreateNew");
          tour.destroy();
        },

        steps: [
          {
            element: menuRef.current as Element,
            popover: {
              title: Loc.currentLang.inviteTourGuide.createNewEntity,
              description: Loc.currentLang.inviteTourGuide.createNewEntityDes,
              side: "right",
              align: "start",

              onNextClick: () => {
                localStorage.removeItem("highlightCreateNew");
                tour.destroy();
              },
            },
          },
        ],
      });

      tour.drive();
    }, 300);

    return () => clearTimeout(timer);
  }, [currentUser]);

  useEffect(() => {
    if (leagueGameEntity?.status === "Started") {
      const attendingPlayerList =
        passEntity?.participants?.filter((p) => p?.status === "Yes") || [];

      const notAttendingPlayerList =
        passEntity?.participants?.filter(
          (p) =>
            p?.status === undefined ||
            p?.status === "No" ||
            p?.status === "RSVP",
        ) || [];

      setAttendingPlayers(attendingPlayerList);
      setNotAttendingPlayers(notAttendingPlayerList);

      setIsAttending(true);
    } else {
      setIsAttending(false);
      setAttendingPlayers([]);
      setNotAttendingPlayers([]);
    }
  }, [passEntity, leagueGameEntity]);

  return (
    <>
      <div ref={menuRef}>
        <Box
          bgColor={"AVColor.white"}
          shadow={4}
          borderRadius={"10px"}
          borderColor={"AVColor.buttonBg"}
          width={"100%"}
          overflow={"hidden"}
        >
          {!isAttending ? (
            <>
              <Text
                fontWeight={"400"}
                fontSize={"24px"}
                color={"AVColor.primary"}
                paddingLeft={"22px"}
                paddingTop={"15px"}
              >
                {Loc.currentLang.post.createNew}
              </Text>

              <VStack width={"100%"} marginTop={"10px"}>
                {/* Team */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Team");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateTeam
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.team}
                    </Text>
                  </HStack>
                </Pressable>

                {/* League */}
                {/*<Pressable*/}
                {/*  isDisabled={*/}
                {/*    currentUser?.status === "NewUser" ||*/}
                {/*    currentUser?.status === "Deleted"*/}
                {/*  }*/}
                {/*  onPress={() => {*/}
                {/*    handleNavigate("LeagueOwner");*/}
                {/*  }}*/}
                {/*  _hover={{*/}
                {/*    backgroundColor: "gray.100",*/}
                {/*  }}*/}
                {/*  height={"40px"}*/}
                {/*  justifyContent={"center"}*/}
                {/*  paddingLeft={"22px"}*/}
                {/*>*/}
                {/*  <HStack space={"11px"}>*/}
                {/*    <Box alignSelf={"center"}>*/}
                {/*      <CreateLeagues*/}
                {/*        width={"27"}*/}
                {/*        height={"20"}*/}
                {/*        color={"#32AE78"}*/}
                {/*      />*/}
                {/*    </Box>*/}

                {/*    <Text fontSize="16px" fontWeight={500}>*/}
                {/*      League*/}
                {/*    </Text>*/}
                {/*  </HStack>*/}
                {/*</Pressable>*/}

                {/* Club */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Club");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateClub
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.club}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Elite Club */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("EliteClub");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateElite
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.eliteclub}
                    </Text>
                  </HStack>
                </Pressable>

                {/* School */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("School");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateSchool
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.school}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Group */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Group");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateGroup
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.group}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Class */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Class");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateClass
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.class}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Graduation Class */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("GradClass");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateGraduation
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.gradClass}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Organization */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Organization");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateOrganization
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.createOrganization}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Neighborhood */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Neighborhood");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateNeighborhood
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.neighborHood}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Community */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("Community");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreateCommunity
                        width={"27"}
                        height={"20"}
                        color={"#32AE78"}
                      />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.community}
                    </Text>
                  </HStack>
                </Pressable>

                {/* Music Group */}
                <Pressable
                  isDisabled={
                    currentUser?.status === "NewUser" ||
                    currentUser?.status === "Deleted"
                  }
                  onPress={() => {
                    handleNavigate("MusicGroup");
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  height={"40px"}
                  justifyContent={"center"}
                  paddingLeft={"22px"}
                >
                  <HStack space={"11px"}>
                    <Box alignSelf={"center"}>
                      <CreatePerformanceGroup width={"27"} height={"20"} />
                    </Box>

                    <Text fontSize="16px" fontWeight={500}>
                      {Loc.currentLang.menu.musicGroup}
                    </Text>
                  </HStack>
                </Pressable>
              </VStack>
            </>
          ) : (
            <>
              {/* HEADER */}
              <Box
                px="20px"
                pt="18px"
                pb="14px"
                borderBottomWidth={1}
                borderBottomColor="#F1F5F9"
              >
                <Text fontSize="22px" fontWeight="600" color="AVColor.primary">
                  {passEntity?.parent?.title}
                </Text>
              </Box>

              {/* BODY */}
              <ScrollView maxH="560px" showsVerticalScrollIndicator={false}>
                <Box px="18px" py="18px">
                  {/* ATTENDING */}
                  <Box mb="28px">
                    <Text
                      fontSize="14px"
                      fontWeight="600"
                      color="#6B7280"
                      mb="16px"
                    >
                      {`${Loc.currentLang.gameEvent.attending} (${attendingPlayers.length})`}
                    </Text>

                    {attendingPlayers.length === 0 ? (
                      <Text
                        fontSize="13px"
                        color="#9CA3AF"
                        textAlign="center"
                        py="12px"
                      >
                        {Loc.currentLang.gameEvent.noAttendingPlayersFound}
                      </Text>
                    ) : (
                      attendingPlayers.map((item, index) => (
                        <HStack key={index} alignItems="center" mb="18px">
                          <Pressable
                            flexDirection="row"
                            alignItems="center"
                            onPress={() => {
                              navigate(`/profile/${item?.id}/${item?.region}`, {
                                state: {
                                  user: {
                                    id: item?.id,
                                    pk: item?.pk,
                                    region: item?.region,
                                    type: item?.type,
                                    name: item?.title,
                                  },
                                },
                              });
                            }}
                          >
                            {/* NUMBER */}
                            {!item?.jerseyNumber ? (
                              <Box
                                width="44px"
                                height="44px"
                                borderRadius="full"
                                bg="coolGray.200"
                                justifyContent="center"
                                alignItems="center"
                                overflow="hidden"
                              >
                                <EntityProfilePic
                                  width={44}
                                  height={44}
                                  link={item}
                                />
                              </Box>
                            ) : (
                              <Box
                                width="46px"
                                height="46px"
                                borderRadius="999px"
                                bg="#E52421"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Text
                                  color="white"
                                  fontWeight="700"
                                  fontSize="18px"
                                >
                                  {item?.jerseyNumber}
                                </Text>
                              </Box>
                            )}

                            {/* DETAILS */}
                            <Box ml="14px">
                              <Text
                                fontSize="14px"
                                fontWeight="700"
                                color="#111827"
                              >
                                {item?.title}
                              </Text>

                              <Text fontSize="13px" color="#6B7280" mt="2px">
                                {item?.position}
                              </Text>
                            </Box>
                          </Pressable>
                        </HStack>
                      ))
                    )}
                  </Box>

                  {/* NOT ATTENDING */}
                  <Box>
                    <Text
                      fontSize="14px"
                      fontWeight="600"
                      color="#6B7280"
                      mb="16px"
                    >
                      {`${Loc.currentLang.gameEvent.notAttending} (${notAttendingPlayers.length})`}
                    </Text>

                    {notAttendingPlayers.length === 0 ? (
                      <Text
                        fontSize="13px"
                        color="#9CA3AF"
                        textAlign="center"
                        py="12px"
                      >
                        {Loc.currentLang.gameEvent.noNotAttendingPlayersFound}
                      </Text>
                    ) : (
                      notAttendingPlayers.map((item, index) => (
                        <HStack key={index} alignItems="center" mb="18px">
                          <Pressable
                            flexDirection="row"
                            alignItems="center"
                            onPress={() => {
                              navigate(`/profile/${item?.id}/${item?.region}`, {
                                state: {
                                  user: {
                                    id: item?.id,
                                    pk: item?.pk,
                                    region: item?.region,
                                    type: item?.type,
                                    name: item?.title,
                                  },
                                },
                              });
                            }}
                          >
                            {/* NUMBER */}
                            {!item?.jerseyNumber ? (
                              <Box
                                width="44px"
                                height="44px"
                                borderRadius="full"
                                bg="coolGray.200"
                                justifyContent="center"
                                alignItems="center"
                                overflow="hidden"
                              >
                                <EntityProfilePic
                                  width={44}
                                  height={44}
                                  link={item}
                                />
                              </Box>
                            ) : (
                              <Box
                                width="46px"
                                height="46px"
                                borderRadius="999px"
                                bg="#E52421"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Text
                                  color="white"
                                  fontWeight="700"
                                  fontSize="18px"
                                >
                                  {item?.jerseyNumber}
                                </Text>
                              </Box>
                            )}

                            {/* DETAILS */}
                            <Box ml="14px">
                              <Text
                                fontSize="14px"
                                fontWeight="700"
                                color="#111827"
                              >
                                {item?.title}
                              </Text>

                              <Text fontSize="13px" color="#6B7280" mt="2px">
                                {item?.position ?? ""}
                              </Text>
                            </Box>
                          </Pressable>
                        </HStack>
                      ))
                    )}
                  </Box>
                </Box>
              </ScrollView>
            </>
          )}
        </Box>
      </div>
    </>
  );
};

export default React.memo(CreateNew);
